import React from "react";
import { useParams } from "react-router";
import { LeadDetailView } from "../../../components/LeadDetailView";
import { useAdminAuth } from "../../auth/AdminAuthContext";

export function ExhibitorLeadDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { user } = useAdminAuth();

  if (!id || !user?.assignedEventId) {
    return null;
  }

  return (
    <LeadDetailView
      eventId={user.assignedEventId}
      leadId={id}
      audience="admin"
      backTo="/exhibitor/leads"
    />
  );
}
